<!-- content begin -->
<div id="content" class="no-bottom no-top">
  <div id="top"></div>

  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/13.jpg)"
    data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
    <div class="overlay-bg t50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>JOB LISTINGS</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->


  <!-- section begin -->
  <div id="section-services" style="padding-top: 20px;">
    <div class="container">

   

      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="row sequence">
            <div class="col-md-12 sq-item wow sq-item wow">

              <div class="feature-box style-2 left cus_ft_box">
                <div class="text">
                  <span routerLink="/notification" onmouseover="mar.stop();" onmouseout="mar.start();"
                    style="position: absolute; background: linear-gradient(to right, #eb3349, #f45c43); padding: 10px; color: #fff; border-radius: 5px; font-size: 18px; z-index: 1; top: 0px;">Notification </span>
                  <marquee id="mar" style="font-size: 18px; color: #000;" onmouseover="mar.stop();" onmouseout="mar.start();"> 
                    <!-- <span *ngFor="let service of cls_marquee;">  {{service.title}} {{service.description}} <a class="notifi_btn" target="_blank"
                      href="{{service.url}}">{{service.button_name}}</a> | </span> -->

                      Due to administrative reasons, the further process of engagement of 78 Consultants(Technical and IT Consultant) of non-training profile at DGT Hqrs. and RDSDEs is cancelled <a href="assets/pdf/OM Tech and IT consultant cancellation.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a>| JC - Revised waiting, list candidates  <a href="assets/pdf/JC waiting  list candidates.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a> | Selected Candidates List for JVC  <a href="assets/pdf/JVC Selected List.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a> | Selected Candidates List for Consultant IT <a href="assets/pdf/Consultant - IT Support - Final (07.01.2022).pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a> | Selected Candidates List for Consultant Technical Support <a href="assets/pdf/Consultant%20-%20Technical%20Support%20(Final)%20-%2007.01.2022%20(1).pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 15px;">Click Here </a>
                      <!-- The location of the vacancies indicated are tentative only. The final posting locations may vary from time to time subject to the requirement of the Organisation | Candidates attending the practical exam for JVC, Consultant IT & Technical support should bring all the relevant original certificates for verification. | The practical exam  date for Consultant IT and Consultant Technical Support on 20th November 2021 -->
                    <!-- JVC Practical Exam will be conducted on 16th November 2021  -->

                  </marquee>

                  <!--| kind Attention JC Practical Shortlisted Candidates - Please Upload your CITS Certificate before 5PM 23-09-2021 |  Practical examination date for JVC, Con(IT) and Con(Technical) will be announced shortly. Pleace keep watching the portal at regular intervals | CBT Exam Result for Junior Vocational Consultants, Consultants (IT Support ) and Consultants (Technical Support ) Shortlisted Candidates List for Practical Exam <a
                    href="http://nimiprojects.in/recruitment/login.php" target="_blank"
                    style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click
                    Here </a>-->
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
          </div>
  </div>

  <!-- section begin -->
  <section id="section-services" data-bgcolor="#f9f9f9" style="padding-top: 0px;">
    <div class="container">


      







      <!-- <div class="row">
        <h2>Current Openings  </h2>
      </div> -->

      <div class="row">

    
         <div class="col-md-4 mb30" *ngFor="let service of cls_vacncy;">
            <div class="picframe wow mb20">
              <a routerLink="/vacncyfulldetail/{{service.refid}}">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="http://localhost:5001/{{service.image}}" class="wow img_cls" alt="" />
              </a>
            </div>
  
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">{{service.dateonly}}</div>
                <div class="d">{{service.monthonly}}</div>
              </div>
  
              <div class="post-content">
                <div class="post-text">
                  <h3> {{service.title}} </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  {{service.salary}}
       <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                      Now</a>
                
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> {{service.location}}  </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   {{service.department}} 
                  </p>
  
                </div>
              </div>
            </div>
          </div>

          <!--<div class="col-md-4 mb30">

         <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/Srconsultant03">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/sanklp1.jpeg" class="wow" alt="" />
              </a>
            </div>
  
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">15</div>
                <div class="d">NOV</div>
              </div>
  
              <div class="post-content">
                <div class="post-text">
                  <h3>  Senior Consultant </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  1,50,000/- to 3,00,000/- 
       <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                      Now</a>
                
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  New Delhi  - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP for NCVET, MSDE, GoI | Full Time
                  </p>
  
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/consultant04">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/ims (8).jpg" class="wow" alt="" />
              </a>
            </div>
  
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">15</div>
                <div class="d">NOV</div>
              </div>
  
              <div class="post-content">
                <div class="post-text">
                  <h3>  Consultant  </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000/- to 2,00,000/-
       <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                      Now</a>
                
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Delhi  - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP for NCVET, MSDE, GoI | Full Time
                  </p>
  
                </div>
              </div>
            </div>
          </div>

            <div class="picframe wow mb20">
              <a routerLink="/consultantSDMRU05">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/ims (1).jpg" class="wow" alt="" />
              </a>
            </div>
  
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">07</div>
                <div class="d">NOV</div>
              </div>
  
              <div class="post-content">
                <div class="post-text">
                  <h3>  Consultant (Research Specialist) for SDMRU                 </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000/- to 2,00,000/-
       <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                      Now</a>
                
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Delhi - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP for NCVET, MSDE, GoI | Full Time
                  </p>
  
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/associatesankalp06">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/sanklp6.jpeg" class="wow" alt="" />
              </a>
            </div>
  
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">07</div>
                <div class="d">NOV</div>
              </div>
  
              <div class="post-content">
                <div class="post-text">
                  <h3>  Associate SANKALP, NIMI SANKALP Cell                   </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000/- to  1,00,000/-
       <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                      Now</a>
                
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Delhi - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP for NCVET, MSDE, GoI | Full Time
                  </p>
  
                </div>
              </div>
            </div>
          </div> -->



     

      </div>

      <!-- <div class="row">
        <hr style="background: red; height: 3px; width: 100%; border: 0px" />
      </div> -->

      <!-- <div class="row">


       
      </div> -->

      <!-- <div class="row">
        <hr style="background: red; height: 3px; width: 100%; border: 0px" />
      </div>

      <div class="row">
        <h2>Current Openings Under Sankalp World Bank Project</h2>
      </div>

      <div class="row">


      </div>
    
       <div class="row">
        <hr style="background: red; height: 3px; width: 100%; border: 0px" />
      </div>  -->

      <div class="row">
        <hr style="background: red; height: 3px; width: 100%; border: 0px" />
      </div>

<!-- <div class="row">
        <h2>New Job Listings</h2> 
      </div> -->
      <div class="row">
        <h2>Old Job Listings</h2>
      </div>
      <!-- <div class="row">
        <hr style="background: red; height: 3px; width: 100%; border: 0px" />
      </div> -->

      <div class="row">
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/secmgd">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/31.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Senior Editor Cum Motion Graphic Designer  </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  40,000 -50,000 /-
                    <button class="appy_now_cls inactive" >Closed</button>
                    <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/svpg">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/32.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Senior Video & Photographer </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  40,000 - 50,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/svemm">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/33.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Senior Video Editor  </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  40,000 - 50,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          </div>

          <div class="row">
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/gaclmm">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/34.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Graphic Artist cum Illustrator   </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000 -35,000 /-
                    <button class="appy_now_cls inactive" >Closed</button>
                    <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/mgdmm">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/35.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Motion graphic designer </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000 - 35,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/smmm">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/36.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Social Media   </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000 - 35,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          </div>

          <div class="row">
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/ardmmm">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/37.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> AR Developer & 3D Modeller   </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000 -35,000 /-
                    <button class="appy_now_cls inactive" >Closed</button>
                    <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/damm">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/38.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> 3D Animators </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000 - 35,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Chennai - 2 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/photomm">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/39.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Photographer   </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  27,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/gdmm">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/40.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">03</div>
                <div class="d">Jul</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Graphic Designer    </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  27,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          </div>
      
      <div class="row">

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/contwrite">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/cw.png" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">30</div>
              <div class="d">Dec</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Content Writer  </h3>
                <!-- <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>50,000-2,00,000/- Per month -->
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                <!-- </p> -->
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/multismc">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/smc.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">30</div>
              <div class="d">Dec</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Social Media  Coordinator  </h3>
                <!-- <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>50,000-2,00,000/- Per month -->
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                <!-- </p> -->
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/multidm">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/dm.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">30</div>
              <div class="d">Dec</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Digital Marketer </h3>
                <!-- <p class="justify_cls"> 2to 3 years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>40,000-50,000/- Per month -->
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                <!-- </p> -->
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>      

        

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/multiys">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ys.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">30</div>
              <div class="d">Dec</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Youtube Specialist </h3>
                <!-- <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>50,000-2,00,000/- Per month -->
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                <!-- </p> --> 
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        
        
      </div>



      

<!-- <div class="row">
        <h2>New Job Listings</h2> 
      </div> -->

      

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/juniorcon24">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/jc_blog.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">29</div>
              <div class="d">Dec</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Junior Consultant  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>Rs. 55,000/- Per month
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register_jc.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> NSTI-G | NSTI-W | CSTARI | Full Time </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   Rs. 55,000/-</p>
  
              </div>
            </div>
          </div>
        </div>
      </div> 


      <div class="row">
              


        
      </div>

      <!-- <div class="row">
        <hr style="background: red; height: 3px; width: 100%; border: 0px" />
      </div> -->
      
      <!-- <div class="row">
        <h2>New Job Listings</h2> 
      </div> -->

      
      

      <div class="row">

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/consanpmu">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/4.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">03</div>
              <div class="d">Sep</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Consultant (SANKALP, PMU Team) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>50,000-2,00,000/- Per month
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/confinacc">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/finacc.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">07</div>
              <div class="d">August</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Consultant (Finance & Accounts) </h3>
                <p class="justify_cls"> 2to 3 years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>40,000-50,000/- Per month
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>      


        
      </div>


      
      

          


        
      

      <div class="row">

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/senit">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/22.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">26</div>
              <div class="d">July</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Senior Consultant (IT) </h3>
                <p class="justify_cls"> 5+ years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>80,000-1,00,000/- Per month
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div> 

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/questai">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/21.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">11</div>
              <div class="d">July</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Consultant (Question Bank - AI) </h3>
                <p class="justify_cls"> 1-3 years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>40,000-50,000/- Per month
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/seniorrnd">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/14.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">23</div>
              <div class="d">Jun</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Senior Consultant (R & D) </h3>
                <p class="justify_cls"> 5years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>60,000-70,000/- Per month
                  <button class="appy_now_cls inactive" >Closed</button>                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        

        
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/senmc">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/15.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">23</div>
                <div class="d">Jun</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Senior Consultant (Multimedia)</h3>
                  <p class="justify_cls"> 5years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>60,000-70,000/- Per month
                    <button class="appy_now_cls inactive" >Closed</button>                  
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          

          
            <div class="col-md-4 mb30">
              <div class="picframe wow mb20">
                <a routerLink="/officesec">
                  <span class="overlay">
                    <span class="title">
                      <span>View More Details</span>
                    </span>
                  </span>
                  <img src="assets/images/blog/16.jpg" class="wow" alt="" />
                </a>
              </div>
      
              <div class="post-item s1 item">
                <div class="date-box">
                  <div class="apy_before">Last Date</div>
                  <div class="m">23</div>
                  <div class="d">Jun</div>
                </div>
      
                <div class="post-content">
                  <div class="post-text">
                    <h3> Office Secretary (Consultant) </h3>
                    <p class="justify_cls"> 3years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>40,000-50,000/- Per month
                      <button class="appy_now_cls inactive" >Closed</button>                  
                     <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
      
                    </p>
                    <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                    <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                    </p>
      
                  </div>
                </div>
              </div>
            </div>
          </div>

            <div class="row">
              <div class="col-md-4 mb30">
                <div class="picframe wow mb20">
                  <a routerLink="/photograp">
                    <span class="overlay">
                      <span class="title">
                        <span>View More Details</span>
                      </span>
                    </span>
                    <img src="assets/images/blog/12.jpg" class="wow" alt="" />
                  </a>
                </div>
        
                <div class="post-item s1 item">
                  <div class="date-box">
                    <div class="apy_before">Last Date</div>
                    <div class="m">23</div>
                    <div class="d">Jun</div>
                  </div>
        
                  <div class="post-content">
                    <div class="post-text">
                      <h3>Senior Consultant (Photographer) </h3>
                      <p class="justify_cls"> 7+years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>60,000-70,000/- Per month
                        <button class="appy_now_cls inactive" >Closed</button>                  
                       <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
        
                      </p>
                      <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> New Delhi - 1 Post </p>
                      <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                      </p>
        
                    </div>
                  </div>
                </div>
              </div>
              </div>


      

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/language">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/2.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">3</div>
              <div class="d">Apr</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Language Translator </h3>
                <p class="justify_cls"> 2years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>35,000-45,000/- Per month
                  <button class="appy_now_cls inactive" >Closed</button>
                  <br>
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 12 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>

        


      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/sconsul">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/images (1).jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">Mar</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Senior Consultant - IT </h3>
                <p class="justify_cls"> 5+ years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>60,000-70,000/- Per month
                  <br>
                  <button class="appy_now_cls inactive" >Closed</button>
                  
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>
        


      

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/consenior">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/images (1).jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">25</div>
              <div class="d">Oct</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Sr. Consultant </h3>
                <p class="justify_cls"> 5-6 years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>70,000/- Per month
                  <button class="appy_now_cls inactive" >Closed</button>
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/coordmulti">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (1).jpg" class="wow" alt="" />
            </a>
          </div>
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">25</div>
              <div class="d">Oct</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Multimedia Coordinator  </h3>
                <p class="justify_cls"> 3-5 years of Experience<br> <i class="fa fa-inr" aria-hidden="true"></i>  50,000/- Per month
              <!-- <p class="justify_cls"> 4+ years of Experience <i class="fa fa-inr" aria-hidden="true"></i>  70,000 - 75,000/- -->
                                    <button class="appy_now_cls inactive" >Closed</button>
                  <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply 
                    Now</a>-->
  
                 </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 9 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>    

            

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/multimco">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (6).jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">08</div>
              <div class="d">Aug</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>  Multimedia Coordinator   </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 40,000 - 50,000 /-
                  <button class="appy_now_cls inactive" >Closed</button>
                  <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 4 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- <div class="row">
          <hr style="background: red; height: 3px; width: 100%; border: 0px" />
        </div> -->
  
        

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/conquestion">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/download.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">24</div>
              <div class="d">Jul</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>  Consultant (Question bank & Exam)  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 45,000 /-
                  <button class="appy_now_cls inactive" >Closed</button>
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/srconmulti">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/images (1).jpg" class="wow" alt="" />
            </a>
          </div>
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">24</div>
              <div class="d">Jul</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Sr. Consultant (Multimedia)  </h3>
                <p class="justify_cls"> 3+ years of Experience <i class="fa fa-inr" aria-hidden="true"></i>  60,000 - 65,000/-
                  <p class="justify_cls"> 4+ years of Experience <i class="fa fa-inr" aria-hidden="true"></i>  70,000 - 75,000/-
                                    <button class="appy_now_cls inactive" >Closed</button>
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                    Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>    
      

      
      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/acccons">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (2).jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">24</div>
              <div class="d">Jul</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>Consultant (Office Secretary)</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>50,000/-PM
                   <button class="appy_now_cls inactive" >Closed</button>
                 <!-- <a hre="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls"> Closed </a> -->
   
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        


      <!-- <div class="row"> -->
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/accountc">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/accounts.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">24</div>
              <div class="d">Jul</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>Consultant (Accounts)</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>45,000/-PM (Consolidated)
                  <button class="appy_now_cls inactive" >Closed</button>
                  <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls"> Apply Now </a> -->
   
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        <!-- </div>
        </div> -->
      </div>
      <!-- <div class="row">
        <hr style="background: red; height: 3px; width: 100%; border: 0px" />
      </div>
      <div class="row">
        <h2>Old Job Listings</h2>
      </div> -->
      
      

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/acccons_#">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (2).jpg" class="wow" alt="" />
            </a>
          </div>
      
      <div class="post-item s1 item">
        <div class="date-box">
          <div class="apy_before">Last Date</div>
          <div class="m">04</div>
          <div class="d">May</div>
        </div>

        <div class="post-content">
          <div class="post-text">
            <h3>Consultant (Office Secretary)</h3>
            <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>50,000/-PM
               <button class="appy_now_cls inactive" >Closed</button>
             <!-- <a hre="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls"> Apply Now </a> -->

            </p>
            <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
            <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
            </p>

          </div>
        </div>
      </div>
    </div>
    


  <!-- <div class="row"> -->
    <div class="col-md-4 mb30">
      <div class="picframe wow mb20">
        <a routerLink="/accountc_#">
          <span class="overlay">
            <span class="title">
              <span>View More Details</span>
            </span>
          </span>
          <img src="assets/images/blog/accounts.jpg" class="wow" alt="" />
        </a>
      </div>

      <div class="post-item s1 item">
        <div class="date-box">
          <div class="apy_before">Last Date</div>
          <div class="m">10</div>
          <div class="d">Apr</div>
        </div>

        <div class="post-content">
          <div class="post-text">
            <h3>Consultant (Accounts)</h3>
            <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>45,000/-PM (Consolidated)
              <button class="appy_now_cls inactive" >Closed</button>
              <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls"> Apply Now </a> -->

            </p>
            <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
            <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
            </p>

          </div>
        </div>
      </div>
    </div>
      
      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/seniorfull_#">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/download.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">09</div>
              <div class="d">Dec</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>  Senior Programmer / Full Stack Developer  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 70,000 - 80,000 /-
                  <button class="appy_now_cls inactive" >Closed</button>
                  <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a>
   -->
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 4 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/pross_#">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/images (1).jpg" class="wow" alt="" />
            </a>
          </div>
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">09</div>
              <div class="d">Dec</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Programmer / Service Support  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  40,000 - 60,000/-
                                    <button class="appy_now_cls inactive" >Closed</button>
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                    Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 4 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
  
        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/datalyst_#">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/dataanalyst.jpg" class="wow" alt=""/>
            </a>
          </div>
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">09</div>
              <div class="d">Dec</div>
            </div>
              <div class="post-content">
              <div class="post-text">
                <h3> Data Analyst   </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 40,000 - 60,000/- 
                  <button class="appy_now_cls inactive" >Closed</button> 
                  <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
                  </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>

        <div class="row">
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/fevidev_#">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/1.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">09</div>
                <div class="d">Dec</div>
              </div>
              <div class="post-content">
                <div class="post-text">
                  <h3>  Front End / UI Developer   </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 40,000 - 60,000 /-
                    <button class="appy_now_cls inactive" >Closed</button>
                    <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/sane_#">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/serveradministra.jpg" class="wow" alt="" />
              </a>
            </div>
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">09</div>
                <div class="d">Dec</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Server Administration / Network Engineer  </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000 - 70,000/-
                                      <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                      Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
    
          
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/systemadm_#">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/systemadminister.jpg" class="wow" alt=""/>
              </a>
            </div>
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">09</div>
                <div class="d">Dec</div>
              </div>
                <div class="post-content">
                <div class="post-text">
                  <h3> System Administrator   </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30,000 - 60,000/- 
                    <button class="appy_now_cls inactive" >Closed</button> 
                    <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
                    </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          </div>

          <div class="row">
            <div class="col-md-4 mb30">
              <div class="picframe wow mb20">
                <a routerLink="/juniorpro_#">
                  <span class="overlay">
                    <span class="title">
                      <span>View More Details</span>
                    </span>
                  </span>
                  <img src="assets/images/blog/juniorpro.jpg" class="wow" alt="" />
                </a>
              </div>
      
              <div class="post-item s1 item">
                <div class="date-box">
                  <div class="apy_before">Last Date</div>
                  <div class="m">09</div>
                  <div class="d">Dec</div>
                </div>
      
                <div class="post-content">
                  <div class="post-text">
                    <h3>  Junior Programmer   </h3>
                    <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 25,000 - 40,000 /-
                      <button class="appy_now_cls inactive" >Closed</button>
                      <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
      
                    </p>
                    <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 5 Post </p>
                    <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                    </p>
      
                  </div>
                </div>
              </div>
            </div>
    
            <div class="col-md-4 mb30">
              <div class="picframe wow mb20">
                <a routerLink="/webmobil_#">
                  <span class="overlay">
                    <span class="title">
                      <span>View More Details</span>
                    </span>
                  </span>
                  <img src="assets/images/blog/mobileapp.jpg" class="wow" alt="" />
                </a>
              </div>
              <div class="post-item s1 item">
                <div class="date-box">
                  <div class="apy_before">Last Date</div>
                  <div class="m">09</div>
                  <div class="d">Dec</div>
                </div>
      
                <div class="post-content">
                  <div class="post-text">
                    <h3> Web and Mobile Application Designer  </h3>
                    <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  40,000 - 50,000/-
                                        <button class="appy_now_cls inactive" >Closed</button>
                     <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                        Now</a> -->
      
                    </p>
                    <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                    <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                    </p>
      
                  </div>
                </div>
              </div>
            <!-- </div> -->
      
            
            <!-- <div class="col-md-4 mb30">
              <div class="picframe wow mb20">
                <a routerLink="/animator">
                  <span class="overlay">
                    <span class="title">
                      <span>View More Details</span>
                    </span>
                  </span>
                  <img src="assets/images/blog/im (5).jpg" class="wow" alt=""/>
                </a>
              </div>
              <div class="post-item s1 item">
                <div class="date-box">
                  <div class="apy_before">Last Date</div>
                  <div class="m">09</div>
                  <div class="d">Dec</div>
                </div>
                  <div class="post-content">
                  <div class="post-text">
                    <h3> 2D and 3D Animators - Unity   </h3>
                    <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30,000 - 50,000/- 
                      <button class="appy_now_cls inactive" >Apply Now</button> 
                       <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> 
                      </p>
                    <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                    <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                    </p>
      
                  </div>
                </div>
              </div>
            </div>-->
            </div> 

            <!-- <div class="row">
              <hr style="background: red; height: 3px; width: 100%; border: 0px" />
            </div> -->

      <!-- <div class="row">
        <h2>Old Job Listings</h2>
      </div> -->

      <!--<div class="row">
        <h2>current Job Listings</h2>
      </div>-->

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/multicons">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (6).jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">26</div>
              <div class="d">Sep</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>  Multimedia Coordinator   </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 40,000 - 50,000 /-
                  <button class="appy_now_cls inactive" >Closed</button>
                  <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/ardevelop">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (2).jpg" class="wow" alt="" />
            </a>
          </div>
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">26</div>
              <div class="d">Sep</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> AR Developers  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000 - 50,000/-
                                    <button class="appy_now_cls inactive" >Closed</button>
                 <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                    Now</a> -->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
  
        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/animator">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/im (5).jpg" class="wow" alt=""/>
            </a>
          </div>
            <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">26</div>
              <div class="d">Sep</div>
            </div>
              <div class="post-content">
              <div class="post-text">
                <h3> 2D and 3D Animators - Unity   </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30,000 - 50,000/- 
                  <button class="appy_now_cls inactive" >Closed</button> 
                  <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
                  </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>

        <div class="row">
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/editor">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/5.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">26</div>
                <div class="d">Sep</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Editor Cum Motion Graphics Designer  </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000 -45,000 /-
                    <button class="appy_now_cls inactive" >Closed</button>
                    <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 5 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/ims (6).jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">26</div>
                <div class="d">Sep</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Unity App Developer </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  40,000 - 70,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a> -->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Chennai - 2 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          </div>
    
  

      <!-- <div class="row">
        <hr style="background: red; height: 3px; width: 100%; border: 0px" />
      </div> -->

      

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/consultant03">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (6).jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">17</div>
              <div class="d">JULY</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>  Consultant- General for SANKALP  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000/-
                  <button class="appy_now_cls inactive" >Closed</button>
                  <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/consultantquest03">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (2).jpg" class="wow" alt="" />
            </a>
          </div>
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">17</div>
              <div class="d">JULY</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Consultant - (Question bank)  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  45,000/-
                                    <button class="appy_now_cls inactive" >Closed</button>
                 <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                    Now</a-->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 4 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
  
        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/consultantdev03">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/im (5).jpg" class="wow" alt=""/>
            </a>
          </div>
            <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">17</div>
              <div class="d">JULY</div>
            </div>
              <div class="post-content">
              <div class="post-text">
                <h3> Consultant – Development  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  45,000/- 
                  <button class="appy_now_cls inactive" >Closed</button> 
                  <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a>-->
                  </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 3 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>

        <div class="row">
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/juniorconsultant03">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/5.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">17</div>
                <div class="d">JULY</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Junior Consultant- General </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  35,000
                    <button class="appy_now_cls inactive" >Closed</button>
                    <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a>-->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Mumbai - 1  and   Kalkata - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/seniorconsultant03">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/ims (6).jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">17</div>
                <div class="d">JULY</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Sr . Consultant </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  1,50,000- 3,00,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a>-->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Delhi - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
    
          
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/consultant0317">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/4.jpg" class="wow" alt=""/>
              </a>
            </div>
              <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">17</div>
                <div class="d">JULY</div>
              </div>
                <div class="post-content">
                <div class="post-text">
                  <h3> Consultant </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000 - 2,00,000 
                    <button class="appy_now_cls inactive" >Closed</button> 
                    <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a>-->
                    </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Delhi - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          </div>

                 
      

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/projectmanager">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (1).jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">09</div>
              <div class="d">JULY</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>  Project Manager  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  90,000- 1,00,000 
                  <button class="appy_now_cls inactive" >Closed</button>
                  <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> New Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/dataanalytics1">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sankalp (5).jpg" class="wow" alt="" />
            </a>
          </div>
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">09</div>
              <div class="d">JULY</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Data Analytics </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  60,000- 70,000
                  <button class="appy_now_cls inactive" >Closed</button>
                 <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                    Now</a-->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
  
        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/seniorpfsd">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/im (5).jpg" class="wow" alt=""/>
            </a>
          </div>
            <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">09</div>
              <div class="d">JULY</div>
            </div>
              <div class="post-content">
              <div class="post-text">
                <h3> Senior Programmer / Full-Stack Developer  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  70,000 - 80,000 
                  <button class="appy_now_cls inactive" >Closed</button> 
                  <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
                  </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Delhi - 4 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>

        <div class="row">
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/senpfsd">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/im (3).jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">09</div>
                <div class="d">JULY</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Senior Programmer / Full-Stack Developer </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  70,000- 80,000 
                    <button class="appy_now_cls inactive" >Closed</button>
                    <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/dataarc">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/4.jpg" class="wow" alt="" />
              </a>
            </div>
    
            <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">09</div>
                <div class="d">JULY</div>
              </div>
    
              <div class="post-content">
                <div class="post-text">
                  <h3> Data Analytics / Report creator </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  60,000- 70,000
                    <button class="appy_now_cls inactive" >Closed</button>
                   <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
    
                  </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Delhi - 1 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
    
          
          <div class="col-md-4 mb30">
            <div class="picframe wow mb20">
              <a routerLink="/programmerss">
                <span class="overlay">
                  <span class="title">
                    <span>View More Details</span>
                  </span>
                </span>
                <img src="assets/images/blog/2.jpg" class="wow" alt=""/>
              </a>
            </div>
              <div class="post-item s1 item">
              <div class="date-box">
                <div class="apy_before">Last Date</div>
                <div class="m">09</div>
                <div class="d">JULY</div>
              </div>
                <div class="post-content">
                <div class="post-text">
                  <h3> Programmer / Service Support </h3>
                  <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000 - 60,000 
                    <button class="appy_now_cls inactive" >Closed</button> 
                    <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
                    </p>
                  <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Delhi - 4 Post </p>
                  <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                  </p>
    
                </div>
              </div>
            </div>
          </div>
          </div>

          <div class="row">
            <div class="col-md-4 mb30">
              <div class="picframe wow mb20">
                <a routerLink="/consul">
                  <span class="overlay">
                    <span class="title">
                      <span>View More Details</span>
                    </span>
                  </span>
                  <img src="assets/images/blog/6.jpg" class="wow" alt="" />
                </a>
              </div>
      
              <div class="post-item s1 item">
                <div class="date-box">
                  <div class="apy_before">Last Date</div>
                  <div class="m">09</div>
                  <div class="d">JULY</div>
                </div>
      
                <div class="post-content">
                  <div class="post-text">
                    <h3>  Consultant </h3>
                    <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  80,000- 90,000 
                      <button class="appy_now_cls inactive" >Closed</button>
                      <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
      
                    </p>
                    <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 1 Post </p>
                    <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                    </p>
      
                  </div>
                </div>
              </div>
            </div>
    
            <div class="col-md-4 mb30">
              <div class="picframe wow mb20">
                <a routerLink="/fullsdapi">
                  <span class="overlay">
                    <span class="title">
                      <span>View More Details</span>
                    </span>
                  </span>
                  <img src="assets/images/blog/sankalp (1).jpg" class="wow" alt="" />
                </a>
              </div>
      
              <div class="post-item s1 item">
                <div class="date-box">
                  <div class="apy_before">Last Date</div>
                  <div class="m">09</div>
                  <div class="d">JULY</div>
                </div>
      
                <div class="post-content">
                  <div class="post-text">
                    <h3> Full-Stack Developer for API & Mobile app </h3>
                    <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  80,000- 90,000
                      <button class="appy_now_cls inactive" >Closed</button>
                     <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
      
                    </p>
                    <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Delhi - 1 Post </p>
                    <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                    </p>
      
                  </div>
                </div>
              </div>
            </div>
      
            
            <div class="col-md-4 mb30">
              <div class="picframe wow mb20">
                <a routerLink="/programmerss1">
                  <span class="overlay">
                    <span class="title">
                      <span>View More Details</span>
                    </span>
                  </span>
                  <img src="assets/images/blog/2.jpg" class="wow" alt=""/>
                </a>
              </div>
                <div class="post-item s1 item">
                <div class="date-box">
                  <div class="apy_before">Last Date</div>
                  <div class="m">09</div>
                  <div class="d">JULY</div>
                </div>
                  <div class="post-content">
                  <div class="post-text">
                    <h3> Programmer / Service Support </h3>
                    <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000 - 60,000 
                      <button class="appy_now_cls inactive" >Closed</button> 
                      <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
                      </p>
                    <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 1 Post </p>
                    <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                    </p>
      
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div class="row">
              <div class="col-md-4 mb30">
                <div class="picframe wow mb20">
                  <a routerLink="/senpfsd1">
                    <span class="overlay">
                      <span class="title">
                        <span>View More Details</span>
                      </span>
                    </span>
                    <img src="assets/images/blog/im (3).jpg" class="wow" alt="" />
                  </a>
                </div>
        
                <div class="post-item s1 item">
                  <div class="date-box">
                    <div class="apy_before">Last Date</div>
                    <div class="m">09</div>
                    <div class="d">JULY</div>
                  </div>
        
                  <div class="post-content">
                    <div class="post-text">
                      <h3> Senior Programmer / Full-Stack Developer </h3>
                      <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  70,000- 80,000 
                        <button class="appy_now_cls inactive" >Closed</button>
                        <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
        
                      </p>
                      <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 4 Post </p>
                      <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                      </p>
        
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4 mb30">
                <div class="picframe wow mb20">
                  <a routerLink="/programmersss">
                    <span class="overlay">
                      <span class="title">
                        <span>View More Details</span>
                      </span>
                    </span>
                    <img src="assets/images/blog/2.jpg" class="wow" alt=""/>
                  </a>
                </div>
                  <div class="post-item s1 item">
                  <div class="date-box">
                    <div class="apy_before">Last Date</div>
                    <div class="m">09</div>
                    <div class="d">JULY</div>
                  </div>
                    <div class="post-content">
                    <div class="post-text">
                      <h3> Programmer / Service Support </h3>
                      <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000 - 60,000 
                        <button class="appy_now_cls inactive" >Closed</button> 
                        <!--a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a-->
                        </p>
                      <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 4 Post </p>
                      <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                      </p>
        
                    </div>
                  </div>
                </div>
              </div>
              </div>

      <!--div class="row">
        <h2>Old Job Listings</h2>
      </div-->

      <div class="row">
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/seniorconsultant1">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/6.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">17</div>
              <div class="d">JUNE</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3>  Senior Consultant I </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  1,50,000- 3,00,000 
                  <button class="appy_now_cls inactive" >Closed</button>
                  <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a>-->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
  
        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/seniorconsultant2">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/4.jpg" class="wow" alt="" />
            </a>
          </div>
  
          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">17</div>
              <div class="d">JUNE</div>
            </div>
  
            <div class="post-content">
              <div class="post-text">
                <h3> Senior Consultant II </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  1,50,000- 3,00,000
                  <button class="appy_now_cls inactive" >Closed</button>
                 <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                    Now</a>-->
  
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>   Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
  
        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/sankalpconsultant">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/3.jpg" class="wow" alt=""/>
            </a>
          </div>
            <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">17</div>
              <div class="d">JUNE</div>
            </div>
              <div class="post-content">
              <div class="post-text">
                <h3> Consultant </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000 - 2,00,000 
                  <button class="appy_now_cls inactive" >Closed</button> 
                  <!--<a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply Now</a>-->
                  </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Full Time
                </p>
  
              </div>
            </div>
          </div>
        </div>
        </div>
  
     


      <div class="row">
      <div class="col-md-4 mb30">
        <div class="picframe wow mb20">
          <a routerLink="/motiongraphicdesigner">
            <span class="overlay">
              <span class="title">
                <span>View More Details</span>
              </span>
            </span>
            <img src="assets/images/blog/5.jpg" class="wow" alt="" />
          </a>
        </div>

        <div class="post-item s1 item">
          <div class="date-box">
            <div class="apy_before">Last Date</div>
            <div class="m">09</div>
            <div class="d">MAY</div>
          </div>

          <div class="post-content">
            <div class="post-text">
              <h3>  Motion Graphic Designer </h3>
              <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  40,000- 45,000 
                <button class="appy_now_cls inactive" >Closed</button>
                <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
             bbn     Now</a> -->

              </p>
              <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 2 Post </p>
              <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
              </p>

            </div>
          </div>
        </div>
      </div>

      
      <div class="col-md-4 mb30">
        <div class="picframe wow mb20">
          <a routerLink="/dataanalystit">
            <span class="overlay">
              <span class="title">
                <span>View More Details</span>
              </span>
            </span>
            <img src="assets/images/blog/6.jpg" class="wow" alt="" />
          </a>
        </div>

        <div class="post-item s1 item">
          <div class="date-box">
            <div class="apy_before">Last Date</div>
            <div class="m">09</div>
            <div class="d">MAY</div>
          </div>

          <div class="post-content">
            <div class="post-text">
              <h3>  Consultant IT - Data Analyst </h3>
              <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  40,000 - 45,000 
                <button class="appy_now_cls inactive" >Closed</button>
               <!--  <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                  Now</a> -->

              </p>
              <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 post , Delhi - 1 Post </p>
              <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
              </p>

            </div>
          </div>
        </div>
      </div>

      
      <div class="col-md-4 mb30">
        <div class="picframe wow mb20">
          <a routerLink="/Sankalp_consultant">
            <span class="overlay">
              <span class="title">
                <span>View More Details</span>
              </span>
            </span>
            <img src="assets/images/blog/4.jpg" class="wow" alt="" />
          </a>
        </div>

        <div class="post-item s1 item">
          <div class="date-box">
            <div class="apy_before">Last Date</div>
            <div class="m">09</div>
            <div class="d">MAY</div>
          </div>

          <div class="post-content">
            <div class="post-text">
              <h3>  Consultant - General  </h3>
              <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  45,000 - 50,000 
                <button class="appy_now_cls inactive" >Closed</button> 
                <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                  Now</a>-->

              </p>
              <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi / Noida - 1 Post </p>
              <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
              </p>

            </div>
          </div>
        </div>
      </div>
      </div>

      


      

      <div class="row">

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Consultant12">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/3.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">07</div>
              <div class="d">FEB</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3>  Consultant  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000/- 2,00,000 
                  <button class="appy_now_cls inactive" disabled>Closed</button> 

                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Srconsultant13">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/2.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">07</div>
              <div class="d">FEB</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Senior Consultant  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 1,50,000/- to 3,00,000/- 
                  <button class="appy_now_cls inactive" disabled>Closed</button> 

              
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/ConsultantDevelopment01">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sanklp1.jpeg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">22</div>
              <div class="d">NOV</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3>  Consultant (Development) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  50,000 
                  <button class="appy_now_cls inactive" disabled>Closed</button> 
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/JuniorConsultantDevelopment02">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sanklp4.jpeg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">22</div>
              <div class="d">NOV</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Junior Consultant (Development)  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 35,000/- 
                  <button class="appy_now_cls inactive" disabled>Closed</button> 
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 4 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Jrcongeneral07">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sanklp6.jpeg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">22</div>
              <div class="d">NOV</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Junior Consultant (General)  </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 35,000/- 
                  <button class="appy_now_cls inactive" disabled>Closed</button> 
              
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Fullstkdevloper09">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/im (2).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">22</div>
              <div class="d">NOV</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3>Full  Stack Developer</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50,000   <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Jrdevloper08">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sankalp (5).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">22</div>
              <div class="d">NOV</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Junior Developer</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 35,000   <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Jrtesteng10">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (4).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">22</div>
              <div class="d">NOV</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Junior Software Test Engineer</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30,000   <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Mobileappdevop11">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (7).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">22</div>
              <div class="d">NOV</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Mobile App Developer</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 40,000   <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/jrJCconsult">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sanklp1.jpeg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">07</div>
              <div class="d">OCT</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Junior Consultant- SANKALP </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i>  30,000 to 1,00,000
                  <button class="appy_now_cls inactive" disabled>Closed</button>

              
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   MSDE | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/legalexpert">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sanklp4.jpeg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">07</div>
              <div class="d">OCT</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Legal Expert </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 6,000/- Per Day 
                  <button class="appy_now_cls inactive" disabled>Closed</button>

              
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Chennai - 1 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   SANKALP | Part Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/consultantAcademics">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/1.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">21</div>
              <div class="d">SEP</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Consultant (Academics) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 40,000 to 50000
                  <button class="appy_now_cls inactive" disabled>Closed</button>

              
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i>  Delhi - 2 Post </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i>   NIMI | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/ContentWriterdgt">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/2.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">15</div>
              <div class="d">AUG</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Content Writer </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50,000 to Rs. 70,000
                  <button class="appy_now_cls inactive" disabled>Closed</button>

                  <!-- <a href="https://nimiprojects.in/recruitment/register.php" target="_blank" class="appy_now_cls">Apply
                    Now</a> -->
                </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> DGT | NIMI | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>


        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/associateCell">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/2.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">08</div>
              <div class="d">AUG</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Associate - SANKALP, NIMI SANKALP Cell </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30,000 to Rs. 1,00,000
                  <button class="appy_now_cls inactive" disabled>Closed</button>

                </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> SANKALP | NIMI | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/associateChennai">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/3.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">08</div>
              <div class="d">AUG</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Associate - SANKALP (Chennai) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30,000 to Rs. 1,00,000
                  <button class="appy_now_cls inactive" disabled>Closed</button>

                </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> SANKALP | NIMI | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>


        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/engagingconult">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/1.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Consultants (IT Support ) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 45000
                  <!-- <button class="appy_now_cls inactive" disabled>Closed</button> -->

                  <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> RDSDE/DGT | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/engagingtech">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/6.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Consultants (Technical Support ) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 45000
                  <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> RDSDE/DGT | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/jvc">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/5.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Junior Vocational Consultants </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 35,000
                  <button class="appy_now_cls inactive" disabled>Apply Now</button>
                </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> 
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NSTI/RDSDE/DGT/CSTARI | Full Time
                </p>

              </div>
            </div>
          </div>
        </div> -->

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Consultantpmumgnf">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/6.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Consultant for (PMU-MGNF) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50,000/- to Rs. 2,00,000


                  <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> SANKALP | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Consultantiis">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (8).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Consultant for (Indian Institute of Skills) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50,000/- to Rs. 2,00,000
                  <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> SANKALP | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Newassociate">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (1).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Associate - SANKALP (Delhi) </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30,000/- to Rs. 1,00,000/-
                  <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> SANKALP | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Ftcsenior">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sanklp1.jpeg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Senior Consultant </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 80,000
                  <!-- <button class="appy_now_cls inactive" disabled>Apply Now</button> -->

                  <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> SANKALP | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Ftcconsultant">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sanklp4.jpeg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Consultant for NCVET, MSDE, GoI </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50000
                  <!-- <button class="appy_now_cls inactive" disabled>Apply Now</button> -->

                  <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> SANKALP | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/Ftcsdmru">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sanklp6.jpeg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">31</div>
              <div class="d">JUL</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Consultant - for SDMRU, MSDE, GoI </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50000
                  <!-- <button class="appy_now_cls inactive" disabled>Closed</button> -->

                  <button class="appy_now_cls inactive" disabled>Closed</button>
                </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> SANKALP | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/contentwriter">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/4.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">01</div>
              <div class="d">JUN</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3>Content Writer and Media Developer for DGT </h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 70,000 to 1,00,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> DGT | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/jconsultant">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/jc_blog.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">07</div>
              <div class="d">MAY</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3>Junior Consultant (Training)</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 45000 <button
                    class="appy_now_cls inactive" disabled>Apply Now</button> </p>
                 <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> 
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NSTI-G | NSTI-W | CSTARI | Full
                  Time </p>

              </div>
            </div>
          </div>
        </div> -->


        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/seniorconsultant">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sankalp (1).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">27</div>
              <div class="d">APR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3>Senior Consultant - SANKALP</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 1.5 to 3 Lakh <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | SANKALP | MSDE | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/iisconsultant">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sankalp (2).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">27</div>
              <div class="d">APR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3>Consultant IIS - SANKALP</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50000 to 2 lakh <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | SANKALP | MSDE | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/consultsankalp">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sankalp (3).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">27</div>
              <div class="d">APR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3> Consultant - SANKALP</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50000 to 2 lakh <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | SANKALP | MSDE | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a routerLink="/associatesankalp">
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sankalp (4).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">27</div>
              <div class="d">APR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3>Associate - SANKALP</h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30000 to 1 lakh <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1 </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | SANKALP | MSDE | Full Time
                </p>

              </div>
            </div>
          </div>
        </div>


        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/im (5).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a> Deputy General Manager (Finance)</a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> Level - 11(Rs.67700-208700) <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <!-- <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai - 2,  Delhi -1  </p> -->
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/4.jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a>Consultant (Human Resources &Travel) </a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai , Delhi </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/sankalp (5).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a>Consultant General</a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Delhi </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>



        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (7).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a> Consultant (Accounts)</a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/im (2).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a>Consultant IT (Full Stack Developer)</a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 50,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (4).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a>Consultant IT (Junior Developers - PHP)</a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 35,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (8).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a> Consultant (Question Bank)</a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 35,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (2).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a>Consultant (Question Bank IT / Translation)</a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 40,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (6).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a> Consultant ( Public Relations) </a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 30,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai , Delhi </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb30">
          <div class="picframe wow mb20">
            <a>
              <span class="overlay">
                <span class="title">
                  <span>View More Details</span>
                </span>
              </span>
              <img src="assets/images/blog/ims (9).jpg" class="wow" alt="" />
            </a>
          </div>

          <div class="post-item s1 item">
            <div class="date-box">
              <div class="apy_before">Last Date</div>
              <div class="m">20</div>
              <div class="d">MAR</div>
            </div>

            <div class="post-content">
              <div class="post-text">
                <h3><a> Consultant (IT and Public Relations) </a></h3>
                <p class="justify_cls"> <i class="fa fa-inr" aria-hidden="true"></i> 35,000 <button
                    class="appy_now_cls inactive" disabled>Closed</button> </p>
                <p class="justify_cls"> <i class="fa fa-map-marker" aria-hidden="true"></i> Chennai </p>
                <p class="justify_cls"> <i class="fa fa-user" aria-hidden="true"></i> NIMI | Full Time </p>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  
  <!-- section close -->

<!-- content close -->

<style>
  .apy_before {
    background: black;
    font-size: 10px;
    line-height: 15px;
    padding: 5px 0px;
  }

  .appy_now_cls {
    background: linear-gradient(to right, #eb3349, #f45c43);
    color: #fff;
    padding: 0px 10px;
    border-radius: 10px;
    position: absolute;
    right: 20px;
  }

  .appy_now_cls.inactive {
    background: grey;
    border: 0px;
  }

  .appy_now_cls.inactive:hover {
    background: grey;
  }

  .appy_now_cls:hover {
    background: linear-gradient(to left, #eb3349, #f45c43);
    cursor: pointer;
  }

  .justify_cls {
    text-align: justify;
  }

  .justify_cls i {
    font-size: 15px;
  }

  .picframe.wow:hover,
  .picframe .overlay,
  .picframe .overlay:hover {
    background: rgba(0, 0, 0, 0.5);
  }

  a:hover {
    text-decoration: none;
    color: #fff;
  }
</style>